import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import DatePickerInput from 'components/DatePickerInput';
import TimeInput from 'components/TimeInput';
import styles from './styles';

const useStyles = makeStyles(styles);

const TimeForm = ({ values, setValues, openCalendar }) => {
  const classes = useStyles();
  const labels = [
    ['Start Date', 'Start Time'],
    ['End Date', 'End Time'],
  ];

  const handleTimeChange = (index) => (time) =>
    setValues((prev) => prev.map((value, i) => (i === index ? { ...value, time } : value)));

  return (
    <Grid container>
      {values.map(({ date, time }, i) => (
        <React.Fragment key={i}>
          <Grid item className={classnames(classes.rootContainer, classes.dateColumn)}>
            <label htmlFor={`date-${i}`} className={classes.label}>
              <Typography variant="body1" color="textSecondary">
                {labels[i][0]}
              </Typography>
              <div className={classes.dateContainer} onClick={openCalendar(i)}>
                <DatePickerInput
                  selectedDay={date}
                  setFieldValue={() => null}
                  field="startDate"
                  // disabled
                  picker
                  fullwidth
                />
              </div>
            </label>
          </Grid>
          <Grid item className={classes.rootContainer}>
            <label className={classes.label}>
              <Typography variant="body1" color="textSecondary">
                {labels[i][1]}
              </Typography>
              <TimeInput
                className={classes.timeField}
                value={time}
                onChange={handleTimeChange(i)}
              />
            </label>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default TimeForm;
